// SETUP COLORS
export const APP_THEME = '#0A0A0F';

export const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#0A0A0F',
  900: '#161C24',
};

export const PRIMARY = {
  lighter: '#7B61FF',
  light: '#7B61FF',
  main: '#7B61FF',
  contrastText: '#000000',
};

export const SECONDARY = {
  lighter: '#7B61FF',
  light: '#7B61FF',
  main: '#7B61FF',
  contrastText: '#000000',
};

export const INFO = {
  light: '#03a9f4',
  main: '#7B61FF',
  dark: '#01579b',
  contrastText: '#000000',
};

export const SUCCESS = {
  light: '#4caf50',
  main: '#4caf50',
  dark: '#2e7d32',
  contrastText: '#000000',
};

export const WARNING = {
  light: '#ff9800',
  main: '#ed6c02',
  dark: '#e65100',
  contrastText: '#000000',
};

export const ERROR = {
  light: '#ef5350',
  main: '#7B61FF',
  dark: '#d32f2f',
  contrastText: '#000000',
};
